import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { DatepickerModule } from '../../../../shared/datepicker/datepicker.module';
import { ChargesService } from '../../../../../services/charges/charges.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PaymentsTableFiltersComponent } from './payments-table-filters.component';

@NgModule({
    imports: [
        SharedModule,
        DatepickerModule,
        MatCheckboxModule,
    ],
    exports: [PaymentsTableFiltersComponent],
    declarations: [PaymentsTableFiltersComponent],
    providers: [
        ChargesService,
    ],
    entryComponents: [],
})
export class PaymentsTableFiltersModule
{
}
